<template>
  <div class="product-show-modular">
    <div class="body-modular">
      <div class="right-item-modualr" v-loading="productLoading">
        <div class="pagination-top-modular">
          <!-- <el-row class="pagination-top-modular-el-row">
                <el-col :span="18" :xs="24">
                  <el-row style="width: 100%">
                    <el-col :span="16" :xs="24"> -->
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            :unique-opened="false"
            style="display: flex"
          >
            <el-menu-item index="1">{{
              // pageText.recommendtarText
              pageTextArr[3]
            }}</el-menu-item>
            <el-menu-item index="2">{{
              // pageText.newText
              pageTextArr[4]
            }}</el-menu-item>
            <el-menu-item index="3">
              <!-- {{  pageText.salesvolumetarText }} -->
              {{ pageTextArr[5] }}
              <img
                v-if="salesFlag == 0"
                class="sales-order-by-icon"
                src="../assets/product/order-by-icon.png"
                alt=""
              />
              <img
                v-else-if="salesFlag == 1"
                class="sales-order-by-icon"
                src="../assets/product/order-by-asc.png"
                alt=""
              />
              <img
                v-else-if="salesFlag == 2"
                class="sales-order-by-icon"
                src="../assets/product/order-by-dasc.png"
                alt=""
              />
            </el-menu-item>
            <!-- <el-menu-item index="4">
                          {{  pageText.appraiseText }}
                          <img v-if="evaluateFlag == 0" class="sales-order-by-icon"
                            src="../assets/product/order-by-icon.png" alt="">
                          <img v-else-if="evaluateFlag == 1" class="sales-order-by-icon"
                            src="../assets/product/order-by-asc.png" alt="">
                          <img v-else-if="evaluateFlag == 2" class="sales-order-by-icon"
                            src="../assets/product/order-by-dasc.png" alt="">
                        </el-menu-item> -->
            <el-menu-item index="5">
              <!-- {{  pageText.pricetarText }} -->
              {{ pageTextArr[6] }}
              <img
                v-if="priceFlag == 0"
                class="sales-order-by-icon"
                src="../assets/product/order-by-icon.png"
                alt=""
              />
              <img
                v-else-if="priceFlag == 1"
                class="sales-order-by-icon"
                src="../assets/product/order-by-asc.png"
                alt=""
              />
              <img
                v-else-if="priceFlag == 2"
                class="sales-order-by-icon"
                src="../assets/product/order-by-dasc.png"
                alt=""
              />
            </el-menu-item>
          </el-menu>
          <!-- </el-col>
                    <el-col :span="8" :xs="24"> -->
          <div class="price-section-modular">
            <el-input
              class="price-item price-start-item"
              v-model="priceStart"
              :placeholder="
                // pageText.pricerangeText
                pageTextArr[11]
              "
            ></el-input>
            <div class="price-line"><span></span></div>
            <el-input
              class="price-item price-end-item"
              v-model="priceEnd"
              placeholder="$"
            ></el-input>
            <div class="search-go-btn">
              <!-- <el-button plain @click="getProductList(1)"
                            >GO</el-button
                          > -->
              <div @click="getProductList(1)" class="goBtn">GO</div>
            </div>
          </div>
          <!-- </el-col>
                  </el-row>
                </el-col>
                <el-col :span="6" :xs="24"> -->
          <div class="pagination-item">
            <div>
              <span class="pagination-curr">{{ page }}</span
              >/<span class="pagination-all">{{
                Math.ceil(pageCount / pagesize)
              }}</span>
            </div>
            <div class="pagination-item-modualr">
              <div class="pagination-left-item" @click="changeCurrpage(false)">
                <img
                  v-if="currpage == 1"
                  src="../assets/product/pagination-left-icon-1.png"
                  alt=""
                />
                <img
                  v-else
                  src="../assets/product/pagination-left-icon-2.png"
                  alt=""
                />
              </div>
              <div class="pagination-right-item" @click="changeCurrpage(true)">
                <img
                  v-if="currpage == totalPage"
                  src="../assets/product/pagination-right-icon-1.png"
                  alt=""
                />
                <img
                  v-else
                  src="../assets/product/pagination-right-icon-2.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <!-- </el-col>
              </el-row> -->
        </div>
        <div class="commodity-show-modular">
          <div v-if="produceListData.length == 0" class="my-evaluate-bodu-none">
            <img
              class="none-icon"
              src="../assets/public/none-icon.png"
              alt=""
            />
            <p class="none-title">
              {{
                // pageText.NoDataText
                pageTextArr[7]
              }}
            </p>
          </div>
          <div
            v-else
            class="commodity-show-item-modualr"
            v-for="(item, index) in produceListData"
            :key="index"
          >
            <div class="commodity-show-item">
              <div class="commodity-show-item-img">
                <img
                  class="commodity-show-img"
                  @click="toProductDetail(item.id)"
                  :src="item.cover"
                  alt=""
                />
              </div>
              <div class="commodity-show-item-msg">
                <div class="commodity-show-item-price">
                  {{ currencySymbol
                  }}{{
                    item.has_discount == 1 ? item.discount_price : item.price
                  }}
                  <span
                    class="commodity-show-item-discpunt-price"
                    v-if="item.has_discount == 1"
                  >
                    {{ currencySymbol }}{{ item.price }}
                  </span>
                </div>
                <div
                  class="commodity-show-item-introduce"
                  @click="toProductDetail(item.id)"
                >
                  {{ currLanguage == 3 ? item.eng_title : item.title }}
                </div>
                <div class="commodity-show-item-evaluate">
                  <div class="commodity-evaluate">
                    <!-- <span class="commodity-evaluate-num">{{
                          item.comment_num
                        }}</span>
                        <span class="commodity-evaluate-title">{{
                           pageText.appraiseText
                        }}</span> -->
                  </div>
                  <div class="commodity-coupon" v-if="item.has_coupon == 1">
                    <!-- {{  pageText.certificateText }} -->
                    {{ pageTextArr[8] }}
                  </div>
                </div>
                <div class="commodity-show-item-operation">
                  <div class="commodity-shop-cart" @click="toProductDetail(item.id)">
                    <span
                      class="add-cart-title"
                    >
                      <!-- {{  pageText.productDetailsText }} -->
                      {{ pageTextArr[10] }}
                    </span>
                  </div>
                </div>
                <div class="commodity-show-item-operation">
                  <!-- <div
                        class="commodity-collection"
                        @click="
                          productaddCollect(item.id, item.is_collect, index)
                        "
                      >
                        <img
                          class="collection-icon"
                          v-if="item.is_collect == 1"
                          src="../assets/home/collection-icon-2.png"
                          alt=""
                        />
                        <img
                          class="collection-icon"
                          v-else
                          src="../assets/home/collection-icon.png"
                          alt=""
                        />
                        <span class="collection-title">{{
                           pageText.collectText
                        }}</span>
                      </div> -->
                  <div class="commodity-shop-cart shop-cart-color" @click="productAddCart(item.id, item.number, 1, '', 1)">
                    <!-- <img
                          class="shop-cart-icon"
                          src="../assets/home/shop-cart-icon.png"
                          alt=""
                        /> -->
                    <span
                      class="add-cart-title"
                    >
                      <!-- {{  pageText.addCartText }} -->
                      {{ pageTextArr[9] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="pagination-footer-modualr">
          <el-pagination
            :pager-count="11"
            :page-size="pagesize"
            :current-page="page"
            background
            layout="prev, pager, next"
            :total="pageCount"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currencySymbol:
        localStorage.getItem("currencySymbol") == null
          ? "$"
          : localStorage.getItem("currencySymbol"),
      searchKey: "", //搜索的关键词
      productLoading: false, //loding
      activeIndex: "1", //产品类别header
      currLanguage: 1, //当前语言
      salesFlag: 0, //销量
      evaluateFlag: 0, //评价
      priceFlag: 0, //价格
      priceStart: "",
      priceEnd: "",
      currpage: 1,
      totalPage: 2, //默认写死1
      page: 1,
      pagesize: 10,
      pageCount: 1,
      produceListData: [], //产品列表
      pageTextArr: [
        "首页",
        "产品",
        "产品类别",
        "推荐",
        "新品",
        "销量",
        "价格",
        "暂无数据",
        "优惠券",
        "加入购物车",
        "产品细节",
        "$ 按价格区间搜索",
      ],
    };
  },
  methods: {
    /**
     * 排序点击
     * @param {*} key
     * @param {*} keyPath
     */
    handleSelect(key, keyPath) {
      let that = this;
      // 1推荐2新品3销量(正序)4销量(倒序)5评价正6评价倒序7价格正序8价格倒序
      switch (parseInt(key)) {
        case 1:
          // 1推荐
          that.getProductList(1);
          break;
        case 2:
          // 2新品
          that.getProductList(2);
          break;
        case 3:
          // 销量 3销量(正序)4销量(倒序)
          that.evaluateFlag = 0; //评价
          that.priceFlag = 0; //价格
          if (that.salesFlag == 2) {
            that.salesFlag = 0;
            that.getProductList(3);
          } else {
            that.salesFlag++;
            if (that.salesFlag == 1) {
              that.getProductList(3);
            } else if (that.salesFlag == 2) {
              that.getProductList(4);
            }
          }
          break;
        case 4:
          // 评价 5评价正6评价倒序
          that.salesFlag = 0; //销量
          that.priceFlag = 0; //价格
          if (that.evaluateFlag == 2) {
            that.evaluateFlag = 0;
            that.getProductList(5);
          } else {
            that.evaluateFlag++;
            if (that.evaluateFlag == 1) {
              that.getProductList(5);
            } else if (that.evaluateFlag == 2) {
              that.getProductList(6);
            }
          }
          break;
        case 5:
          // 价格  7价格正序8价格倒序
          that.salesFlag = 0; //销量
          that.evaluateFlag = 0; //评价
          if (that.priceFlag == 2) {
            that.priceFlag = 0;
            that.getProductList(7);
          } else {
            that.priceFlag++;
            if (that.priceFlag == 1) {
              that.getProductList(7);
            } else if (that.priceFlag == 2) {
              that.getProductList(8);
            }
          }
          break;

        default:
          that.salesFlag = 0;
          that.evaluateFlag = 0;
          that.priceFlag = 0;
          break;
      }
    },
    /**
     * 顶部翻页
     * @param {*} type
     */
    changeCurrpage(type) {
      let that = this;
      that.productLoading = true;
      if (type) {
        if (that.currpage == that.totalPage) {
          that.currpage = that.totalPage;
        } else {
          that.currpage++;
        }
      } else {
        if (that.currpage == 1) {
          that.currpage = 1;
        } else {
          that.currpage--;
        }
      }
      that.page = that.currpage;
      that.getProductList(that.currProductType);
    },
    /**
     * 分页点击
     * @param {*} val
     */
    handleCurrentChange(val) {
      let that = this;
      that.page = val;
      that.getProductList(that.currProductType);
    },
    /**
     * 跳转-详情
     * @param {*} id
     */
    toProductDetail(id) {
      this.$router.push({
        path: "/productDetail",
        query: { product_id: id },
      });
    },
    /**
     * 产品列表
     * @param {*} type
     */
    getProductList(type) {
      let that = this;
      //loading
      that.productLoading = true;
      that.currProductType = type;
      let data = {
        page: that.page,
        pagesize: that.pagesize,
        key: that.searchKey, //搜索值
        typeid: that.currProductTypeId, //分类id
        type: type, //1推荐2新品3销量(正序)4销量(倒序)5评价正6评价倒序7价格正序8价格倒序
        start_price: that.priceStart, //开始价格
        end_price: that.priceEnd, //结束价格
        exchange_rate: localStorage.getItem("currencyRate"), //汇率值
      };
      this.$http.getProductList(
        data,
        (res) => {
          if (res.ret == 1) {
            that.produceListData = res.data;
            that.pageCount = parseInt(res.total);
            that.productLoading = false;
            that.totalPage = Math.ceil(that.pageCount / that.pagesize);
            that.translateApiData(res.data, "title");
          } else {
            that.produceListData = [];
            // this.$message.error(res.msg);
            that.productLoading = false;
          }
        },
        (res) => {
          that.productLoading = false;
          that.produceListData = [];
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 商品加入购物车
     * @param {*} product_id
     * @param {*} sku_number
     * @param {*} type
     * @param {*} portfolio_sales_middle_id
     * @param {*} cartNum
     */
    productAddCart(
      product_id,
      sku_number,
      type,
      portfolio_sales_middle_id,
      cartNum
    ) {
      let that = this;
      // if (this.$parent.tipsLogin()) return;
      that.$parent.addCart(
        product_id,
        sku_number,
        type,
        portfolio_sales_middle_id,
        cartNum,
      );
    },
    /**
     * 获取页面参数
     */
    getProductTypeByUrl() {
      let that = this;
      this.$parent.$refs.headerModular.searchKey = that.searchKey;
      // 产品列表
      that.getProductList(1);
    },
    translateByArr(arr, callback, errCallBack) {
      let that = this;
      let data = {
        text: arr, //带翻译数组
        from: localStorage.getItem("oldLanguageCode"), //源语言
        to: localStorage.getItem("curLanguageCode"), //目标语言
      };
      if (data.from == data.to) {
        return;
      }
      this.$http.translateByArr(data, callback, errCallBack);
    },

    /**
     * 处理APIde数据进行翻译
     * @param {*} data  newTextArr
     */
    translateApiData(data, title) {
      let that = this;
      let newTextArr = [];
      data.forEach((v, i) => {
        for (const key in v) {
          if (key == title) {
            newTextArr.push(v[key]);
          }
        }
      });
      that.languageTranslateByArr(newTextArr, title, 0);
    },
    /**
     * 语言翻译 - 数组
     * @param {*} arr
     */
    languageTranslateByArr(arr, title, lev) {
      let that = this;
      this.$parent.translateByArr(
        arr,
        (res) => {
          console.log("languageTranslateByArr", res);
          // 翻译api类型
          that.processingResultsByArr(res.data, title, lev);
        },
        (res) => {}
      );
    },
    /**
     * api 处理返回的翻译数据
     * @param {*} data
     */
    processingResultsByArr(data, title, lev) {
      let that = this;
      switch (lev) {
        // 商品接口数据
        case 0:
          data.forEach((v, i) => {
            that.produceListData[i][title] = v.translation;
          });
          break;
          default:
          break;
      }
    },

    languageTranslateByArrs(arr) {
      let that = this;
      let newpagetextArr = [];
      that.translateByArr(arr, (res) => {
        console.log("res", res);
        res.data.forEach((item, index) => {
          newpagetextArr.push(item.translation);
        });
        that.pageTextArr = newpagetextArr;
      });
    },
  },
  mounted() {
    let that = this;
    let url = window.location.href;
    console.log("url", url);
    localStorage.setItem("url", url);
    // 当前语言
    that.currLanguage = localStorage.getItem("curLanguageType");
    // 搜索关键词
    that.searchKey = that.$route.query.searchKey;

    // 获取页面参数
    setTimeout(() => {
      that.getProductTypeByUrl();
    }, 500);
    // 翻译
    // that.pageTranslate();

    that.languageTranslateByArrs(that.pageTextArr);
  },
};
</script>
<style lang="scss" scoped>
.product-show-modular {
  .body-modular {
    margin-top: 20px;
    .right-item-modualr {
      .commodity-show-modular {
        .commodity-show-item-modualr {
          width: 224px;
          margin-right: 20px;
        }
        .commodity-show-item-modualr:nth-child(5n) {
          margin-right: 0;
        }
      }
    }
  }
}
@media screen and (max-width: 500px) {
  .product-show-modular {
    .body-modular {
      .right-item-modualr {
        .commodity-show-modular {
          .commodity-show-item-modualr {
            margin-right: 0;
          }
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/view/searchProduct.vue